import request from './axiosFun';
import apiHttp from './apiHttp';

var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}

// 获取列表
export function getTaskInfoList(query) {
  return request({
    url: url + '/livestock/materInfo/getTaskInfoList ',
    method: 'post',
    data: query
  });
}
// 大数据-使用量统计
export function getUsageDataLivestockCount(query) {
  return apiHttp({
    url: url + '/livestock/outStockInfo/getUsageDataLivestockCount',
    method: 'post',
    data: query
  });
}
// 大数据-图例
export function selectMaterInfoList(query) {
  return apiHttp({
    url: url + '/livestock/materInfo/selectMaterInfoList',
    method: 'post',
    data: query
  });
}
// 大数据-图例
export function selectCalfMaterInfoList(query) {
  return apiHttp({
    url: url + '/project-server/calfDataInfo/selectCalfMaterInfoList',
    method: 'post',
    data: query
  });
}
// 大屏畜只统计数据
export function getDataLivestockCount(query) {
  return apiHttp({
    url: url + '/livestock/outStockInfo/getDataLivestockCount',
    method: 'post',
    data: query
  });
}
// 查询字典
export function findDictList(query) {
  return apiHttp({
    url: url + '/base-server/homeCenter/sysInfo/findDictList',
    method: 'post',
    data: query
  });
}
// 获取飞线点位信息
export function areaCoordinateList(query, loading) {
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/livestock/outStockInfo/areaCoordinateList',
    method: 'post',
    data: query
  });
}
// 获取pcode
export function getPcaCode(query) {
  return apiHttp({
    url: url + '/pasture/sys/getPcaCode',
    method: 'post',
    data: query
  });
}
// 获取排名
export function getRankingOfEpidemicPrevention(query) {
  return apiHttp({
    url: url + '/pasture/sys/getRankingOfEpidemicPrevention',
    method: 'post',
    data: query
  });
}
// 获取路径
export function areaPersCoordinateList(query) {
  return apiHttp({
    url: url + '/livestock/outStockInfo/areaPersCoordinateList',
    method: 'post',
    data: query
  });
}

// 阿里地图数据
export function aliMapData(query) {
  return apiHttp({
    url: url + '/base-server/userCore/aliMapData',
    method: 'post',
    data: query
  });
}

/* 假数据 - 智慧牧场 */
export function getDeviceInfo_JSJ(data) {
  return apiHttp({
    url: url + '/project-server/wisdomFarm/getDeviceInfo',
    method: 'post',
    data: data
  });
}

/* 假数据 - 畜只信息检测 */
export function queryShedLivestockOtherTag_JSJ(data) {
  return apiHttp({
    url: url + '/project-server/wisdomFarm/queryShedLivestockOtherTag/3',
    method: 'post',
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/statistics.js